module.exports = __webpack_public_path__ + "img/Gyu-Kaku.416fbbe5.svg";